import styled from "styled-components";
import { Button } from "antd";
import { Copy } from "assets/images";

export const Container = styled.div`
    width: 100%;
    background: #e7efe7;
`;

export const ModalBody = styled.div`
    padding: 20px;
    font-size: 18px;

    > div:nth-child(n + 2) {
        margin-top: 15px;
    }
`;

export const ItemBlock = styled.div``;

export const Label = styled.div`
    font-weight: 600;
    font-size: 14px;
`;

export const FileName = styled.div`
    margin-top: 8px;
    width: 100%;
    background-color: white;
    padding: 12px 17px;
    border-radius: 6px;
`;

export const Size = styled(FileName)`
    font-weight: 800;
    background-color: ${({ theme }) => theme.color.historyTableHeader};
`;

export const LinkBlock = styled(FileName)`
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

interface LinkProps {
    title: string;
}

export const Link = styled.div<LinkProps>`
    width: 90%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const CopyImg = styled(Copy)`
    :hover {
        cursor: pointer;
    }
`;

export const SaveButton = styled(Button)`
    display: flex;
    height: auto;
    margin-top: 30px;
    margin-right: 0;
    margin-left: auto;
    padding: 11px 30px;
    background: ${({ theme }) => theme.color.settingsBackground};
    font-size: 12px;
    color: white;
    border-radius: 10px;

    :hover {
        background: white;
        color: ${({ theme }) => theme.color.settingsBackground};
        border-color: ${({ theme }) => theme.color.settingsBackground};
    }
`;
